<ion-button [disabled]="disabled" class="arrow-button">
    <div class="icons" start>
        @if (leftIcon) {
            <ion-icon [src]="'assets/icon/' + leftIcon" class="white"> </ion-icon>
        }
    </div>
    <p class="button-wifi-label">
        {{ label }}
        <ng-content></ng-content>
    </p>
    <div class="icons" end>
        @if (rightIcon) {
            <ion-icon [src]="'assets/icon/' + rightIcon"> </ion-icon>
        }
        <ion-icon name="chevron-forward-outline"></ion-icon>
    </div>
</ion-button>
